/**
 * Created by seaasun on 2017/12/28.
 */
import Vue from "vue";
import router from "@/router";
import utils from "@/assets/utils/index";
import priceHelp from "@/assets/priceHelp";
import notification from "@/components/common/notification";
import app from "@/main";
import order from "@/config/order";

function hasDemoValue(column, AttributeValue) {
  for (let item of column.Values) {
    if (item.AttributeValue === AttributeValue) {
      return true;
    }
  }
  return false;
}

function countError(commit, name, state, resp) {
  utils.progressDone();
  app.$root.$emit("bv::hide::modal", "modal-counting");
  notification.notice("error", "please try again", {
    title: "Count Error",
    actions: [],
    duration: 10000
  });
  commit("saveKey", ["CurrentStep", "input"]);
  utils.log(
    "count",
    name,
    {
      url: resp.url,
      body: resp.body,
      status: resp.status,
      statusText: resp.statusText
    },
    state
  );
}

export default {
  initOrder({ commit, rootState }, listType) {
    /*  init order
      listType: number
     */
    commit("saveOrder", order());
    if (listType) {
      commit("saveListType", listType);
    }
    if (rootState.user.accountId) {
      commit("saveKey", ["AccountId", rootState.user.accountId]);
    }
  },
  slcPollOrder({ state, commit, dispatch, rootState }) {
    if (state.CurrentStep === "count") {
      return false;
    }
    if (rootState.site.isSLC) {
      commit("site/saveKey", ["slcCountNum", rootState.site.slcCountNum + 1]);
    }
    commit("saveKey", ["CurrentStep", "count"]);
    utils.progressStart();
    app.$root.$emit("bv::show::modal", "modal-counting");
    utils.log("submitOrder", "submitOrder", "submitOrder", state);
    dispatch("pollCount");
  },
  submitOrder({ state, commit, dispatch, rootState }) {
    /* start get count

      Get Count work flow:
      1. submitOrder
      2. start poll count
      3. check poll count
      4. get order
      5. progress order
      6. get order contact
     */
    if (state.CurrentStep === "count") {
      return false;
    }

    if (rootState.site.isSLC) {
      commit("site/saveKey", ["slcCountNum", rootState.site.slcCountNum + 1]);
    }

    commit("saveKey", ["CurrentStep", "count"]);
    utils.progressStart();
    app.$root.$emit("bv::show::modal", "modal-counting");

    utils.log("submitOrder", "submitOrder", "submitOrder", state);
    Vue.http
      .post(
        "PlaceOrder.aspx/SubmitOrder",
        {
          order: state
        },
        {
          progressBar: false,
          errorType: "silent"
        }
      )
      .then(
        resp => {
          commit("saveOrder", resp.body.d.DataSource);
          dispatch("pollCount");
        },
        resp => {
          countError(commit, "submit", state, resp);
        }
      );
  },
  pollCount({ state, commit, dispatch }) {
    // Vue.http.post('PlaceOrder.aspx/PollCount', {
    Vue.http
      .post(
        "PlaceOrder.aspx/PollCountWithotSession",
        {
          orderId: 13402,
          order: state
        },
        {
          progressBar: false,
          errorType: "silent"
        }
      )
      .then(
        resp => {
          // stop count if users stop
          if (state.CurrentStep !== "count") {
            return false;
          }
          commit("saveOrder", resp.body.d.DataSource.Order);
          dispatch("checkPollCount", resp.body.d.DataSource.RequestId);

          // setTimeout(() => {
          //   dispatch('checkPollCount', resp.body.d.DataSource.RequestId)
          // }, 1000)
        },
        resp => {
          utils.progressDone();
          countError(commit, "pollCount", state, resp);
        }
      );
  },
  checkPollCount({ state, commit, dispatch }, requestId) {
    // Vue.http.post('PlaceOrder.aspx/CheckPollingStatus', {
    Vue.http
      .post(
        "PlaceOrder.aspx/CheckPollingStatusWithoutSeesion",
        {
          requestId: requestId,
          order: state
        },
        {
          progressBar: false,
          errorType: "silent"
        }
      )
      .then(
        resp => {
          // stop count if users stop
          if (state.CurrentStep !== "count") {
            return false;
          }
          if (resp.body.d.DataSource.PercentComplete < 100) {
            // let count = 0

            setTimeout(() => {
              // count += 1
              dispatch("checkPollCount", resp.body.d.DataSource.RequestId);
            }, 1000);
          } else {
            dispatch("getOrder", requestId);
          }
        },
        resp => {
          countError(commit, "checkPollCount", state, resp);
        }
      );
  },
  getOrder({ state, commit, dispatch }, requestId) {
    Vue.http
      .post(
        "PlaceOrder.aspx/GetOrderAndPriceList2WithoutSession",
        {
          // Vue.http.post('PlaceOrder.aspx/PollCount', {
          listtype: 10,
          istest: false,
          order: state,
          requestId: requestId
        },
        {
          progressBar: false,
          errorType: "silent"
        }
      )
      .then(
        resp => {
          dispatch("user/getUserPaymentCard", null, { root: true });

          commit("saveOrder", resp.body.d.DataSource.Order);
          commit("saveKey", ["CurrentStep", "count"]);

          delete resp.body.d.DataSource.Order;
          commit("summary/saveSummary", resp.body.d.DataSource, { root: true });

          utils.progressDone();
          app.$root.$emit("bv::hide::modal", "modal-counting");
          commit("saveKey", ["CurrentStep", "summary"]);
          dispatch("progressOrder");
          router.push({ name: "summary" });
        },
        resp => {
          countError(commit, "pollCount", state, resp);
        }
      );
  },
  progressOrder({ commit, dispatch }) {
    dispatch("getOrderContact");
    dispatch("calculatePrice");
  },
  getOrderContact({ state, getters, commit, rootState }) {
    Vue.http.post("PlaceOrder.aspx/GetUserInformation", {}).then(resp => {
      let user = resp.body.d.DataSource;

      if (user.HomePhone) {
        var phone = user.HomePhone;
        phone = phone
          .replace("(", "")
          .replace(")", "")
          .replace(" ", "")
          .replace("x", "")
          .replace("-", "");
        phone = `(${phone.substr(0, 3)}) ${phone.substr(3, 3)}-${phone.substr(
          6,
          4
        )}`;
      } else {
        phone = "";
      }

      // TODO@PONY uc.payment.IsContactAddressComplete
      let address = {};
      if (
        rootState.summary.IsContactAddressComplete &&
        user.UsersAddress.length >= 1
      ) {
        address = user.UsersAddress[0];
      } else {
        address = {
          AddressLine: "",
          CityName: "",
          CountryCode: "US",
          StateCode: "",
          ZipCode: null
        };
      }

      commit("saveKey", [
        "OrderContactInformation",
        {
          AddToMailingList: false,
          AddressLine: address.AddressLine,
          CallMe: false,
          City: address.CityName,
          Company: user.Company,
          CountryCode: address.CountryCode,
          Email: user.Email,
          FirstName: user.FirstName,
          LastName: user.LastName,
          IsContactMeByEmail: false,
          IsSendEmailToAudience: false,
          IsSendEmailToList: false,
          IsSendMobileFacebookToAudience: false,
          LicenseNumber: user.LicenseNumber,
          OrderForClients: false,
          OrderName: "",
          Phone: phone,
          SANNumber: user.SANNumber,
          SANNumberLastUpdatedDateTime: user.SANNumberLastUpdatedDateTime,
          State: address.StateCode,
          Zipcode: address.ZipCode
        }
      ]);
      commit("summary/saveKey", ["userInformation", resp.body.d.DataSource], {
        root: true
      });

      // save paymentInformation
      if (getters["isCreditCard"]) {
        commit("saveKey", [
          "OrderPaymentInformation",
          {
            AddressLine:
              rootState.user.userPaymentCard.Address || address.AddressLine,
            CardType: rootState.user.userPaymentCard.CardType || 10,
            City: rootState.user.userPaymentCard.City || address.CityName,
            CountryCode: address.CountryCode,
            Email: user.Email,
            ExpiredMonth:
              rootState.user.userPaymentCard.ExpirationMonth ||
              new Date().getMonth(),
            ExpiredYear:
              rootState.user.userPaymentCard.ExpirationYear ||
              new Date().getFullYear() + 1,
            HolderName: rootState.user.userPaymentCard.HolderName || "",
            LegatoMessage: "",
            Number: rootState.user.userPaymentCard.CardNumber || "",
            Phone: phone,
            SecurityCode: rootState.user.userPaymentCard.CVV || "",
            State:
              rootState.user.userPaymentCard.State || address.StateCode || "",
            Token: "",
            Zipcode:
              rootState.user.userPaymentCard.ZipCode || address.ZipCode || ""
          }
        ]);
      }

      // TODO PONY ,paymentMethod, card:1; no card 2
      // commit('saveKey', ['PaymentMethod', rootState.site.IsUserNoPay ? 1 : 2])
      commit("saveKey", ["OrderDesc", ""]);
    });
  },
  //  ==== demo
  addDemoByItem({ state, getters, commit }, payload) {
    // ColumnName
    // DemoCategoryType
    // AttributeName
    // AttributeValue
    // AttributeValueName
    // SortSeq
    // Description
    let index = getters.demoColumnIndex(
      payload.ColumnName,
      payload.DemoCategoryType
    );
    let val = {
      AttributeValue: payload.AttributeValue,
      AttributeValueName: payload.AttributeValueName || "",
      ColumnName: payload.ColumnName,
      SortSeq: payload.SortSeq || ""
    };
    // pusha a new column
    if (index === -1) {
      commit("addNewDemo", {
        AttributeName: payload.AttributeName || "",
        ColumnName: payload.ColumnName,
        DemoCategoryType: payload.DemoCategoryType || 0,
        Description: payload.Description || "",
        Values: [val]
      });
    } else {
      let column = state.OrderSelectedDemos[index];
      // only push value
      if (!hasDemoValue(column, payload.AttributeValue)) {
        commit("addNewDemoValue", {
          index,
          val
        });
      }
    }
  },
  deleteDemo({ state, getters, commit }, payload) {
    /*
      type: 'value', 'column'
      columnName:
      demoCategoryType:
      attributeValue：
    */
    payload = payload || {};
    let type = payload.type || "value";
    payload.columnName = payload.columnName + "";
    let index = getters.demoColumnIndex(
      payload.columnName,
      payload.demoCategoryType
    ); // TODO@PONY not good var name
    if (type === "column") {
      commit("deleteDemo", index);
    } else {
      let column = getters.demoColumnItem(
        payload.columnName,
        payload.demoCategoryType
      );
      if (column && column.Values.length === 1) {
        commit("deleteDemo", index);
      } else if (column) {
        for (let i = 0; i < column.Values.length; i++) {
          if (payload.attributeValue === column.Values[i].AttributeValue) {
            commit("deleteDemoValue", {
              index: index,
              valueIndex: i
            });
            break;
          }
        }
      }
    }
  },
  toggleAddDemoBusinessType({ dispatch }, payload) {
    let val = payload.val;
    let code = payload.industryCode || "";
    let desc = payload.IndustryDesc || "";
    if (payload.deep !== 0) {
      if (val) {
        dispatch("addDemoByItem", {
          AttributeName: `${payload.parentItem.data}(Add)`,
          ColumnName: payload.parentItem.attributes.IndustryCode,
          DemoCategoryType: 4,
          AttributeValue: code,
          AttributeValueName: desc,
          SortSeq: 0
        });
      } else {
        dispatch("deleteDemo", {
          type: "value",
          columnName: payload.parentItem.attributes.IndustryCode,
          attributeValue: code,
          demoCategoryType: 4
        });
      }
    } else {
      for (let item of payload.values) {
        if (val) {
          dispatch("addDemoByItem", {
            AttributeName: `${payload.parentItem.data}(Add)`,
            ColumnName: payload.parentItem.attributes.IndustryCode,
            DemoCategoryType: 4,
            AttributeValue: item.attributes.IndustryCode,
            AttributeValueName: item.data,
            SortSeq: 0
          });
        } else {
          dispatch("deleteDemo", {
            type: "value",
            columnName: payload.parentItem.attributes.IndustryCode,
            attributeValue: item.attributes.IndustryCode,
            demoCategoryType: 4
          });
        }
      }
    }
  },
  toggleOmitDemoBusinessType({ dispatch }, payload) {
    let val = payload.val;
    let code = payload.industryCode || "";
    let desc = payload.IndustryDesc || "";
    if (payload.deep !== 0) {
      if (val) {
        dispatch("addDemoByItem", {
          AttributeName: `${payload.parentItem.data}(Omit)`,
          ColumnName: payload.parentItem.attributes.IndustryCode,
          DemoCategoryType: 6,
          AttributeValue: code,
          AttributeValueName: desc,
          SortSeq: 0
        });
      } else {
        dispatch("deleteDemo", {
          type: "value",
          columnName: payload.parentItem.attributes.IndustryCode,
          demoCategoryType: 6,
          attributeValue: code // TODO@PONY ColumnName sometimes is same THI
        });
      }
    } else {
      for (let item of payload.values) {
        if (val) {
          dispatch("addDemoByItem", {
            AttributeName:  `${payload.parentItem.data}(Omit)`,
            ColumnName: payload.parentItem.attributes.IndustryCode,
            DemoCategoryType: 6,
            AttributeValue: item.attributes.IndustryCode,
            AttributeValueName: item.data,
            SortSeq: 0
          });
        } else {
          dispatch("deleteDemo", {
            type: "value",
            columnName: payload.parentItem.attributes.IndustryCode,
            demoCategoryType: 6,
            attributeValue: item.attributes.IndustryCode // TODO@PONY ColumnName sometimes is same THI
          });
        }
      }
    }
  },
  changeGeoType({ state, commit }, geoType) {
    // @geoType int
    if (geoType !== state.GeoType) {
      // If GeoType is more area
      // if (state.GeoType === 23 && (geoType === 5 || geoType === 4 || geoType === 2 || geoType === 3)) {
      //   return
      // }
      commit("cleanGeo");
      commit("saveKey", ["GeoType", geoType]);
    }
  },
  calculatePrice({ state, commit, getters }) {
    let order = priceHelp.updatePrice();
    commit("saveOrder", order);
  },
  getReommendOrder({ commit, dispatch }, payload) {
    Vue.http
      .post("PlaceOrder.aspx/GetRecSysDemosNoSession", {
        orderid: payload.orderid,
        columnname: payload.columnname
      })
      .then(resp => {
        // let demos = resp.body.d.DataSource
        commit("demo/saveKey", ["recommendDemos", resp.body.d.DataSource], {
          root: true
        });
        router.push({
          name: "demo",
          params: { listType: 10 }
        });
      });
  },
  getOrderAndCount({ dispatch, commit }, orderId) {
    Vue.http
      .post("PlaceOrder.aspx/GetOrder", {
        orderId: 25822
      })
      .then(resp => {
        commit("saveOrder", resp.body.d.DataSource);
        dispatch("submitOrder");
      });
  },
  updateSuppressionType({ commit, rootState }, item) {
    let dict = rootState.config.suppressionTypeMap;
    let id = 0;
    for (let key of Object.keys(dict)) {
      if (
        item.order === dict[key].order &&
        item.slc === dict[key].slc &&
        item.file === dict[key].file
      ) {
        id = key;
        break;
      }
    }
    if (item.order === "date") {
      commit("saveKey", ["OrderSuppressions", []]);
    }
    if (item.slc === "date") {
      commit("saveKey", ["SaveCountSuppressions", []]);
    }
    if (item.file === "date") {
      commit("saveKey", ["CustomSuppressions", []]);
    }
    commit("saveKey", ["SuppressionType", parseInt(id)]);
  },
  changeGeoCount({ state, commit, dispatch }, payload) {
    let ordergeos = state.OrderGeos;
    let homeTotal = 0;
    let aptsTotal = 0;
    let bussTotal = 0;
    for (var i = 0; i < ordergeos.length; i++) {
      if (i === payload.index) {
        let geo = ordergeos[payload.index];
        if (payload.type === "homes") {
          if (payload.checked) {
            geo.DesiredQtyHome = geo.AvailableQtyHome;
          } else {
            geo.DesiredQtyHome = 0;
          }
          for (let item of geo.OrderGeoDetails) {
            if (payload.checked) {
              item.DesiredQtyHome = item.AvailableQtyHome;
            } else {
              item.DesiredQtyHome = 0;
            }
            item.DesiredQty =
              item.DesiredQtyApt + item.DesiredQtyBuss + item.DesiredQtyHome;
          }
        } else if (payload.type === "apts") {
          if (payload.checked) {
            geo.DesiredQtyApt = geo.AvailableQtyApt;
            for (let item of geo.OrderGeoDetails) {
              item.DesiredQtyApt = item.AvailableQtyApt;
              item.DesiredQty =
                item.DesiredQtyApt + item.DesiredQtyBuss + item.DesiredQtyHome;
            }
          } else {
            geo.DesiredQtyApt = 0;
            for (let item of geo.OrderGeoDetails) {
              item.DesiredQtyApt = 0;
              item.DesiredQty =
                item.DesiredQtyApt + item.DesiredQtyBuss + item.DesiredQtyHome;
            }
          }
        } else if (payload.type === "business") {
          if (payload.checked) {
            geo.DesiredQtyBuss = geo.AvailableQtyBuss;
            for (let item of geo.OrderGeoDetails) {
              item.DesiredQtyBuss = item.AvailableQtyBuss;
              item.DesiredQty =
                item.DesiredQtyApt + item.DesiredQtyBuss + item.DesiredQtyHome;
            }
          } else {
            geo.DesiredQtyBuss = 0;
            for (let item of geo.OrderGeoDetails) {
              item.DesiredQtyBuss = 0;
              item.DesiredQty =
                item.DesiredQtyApt + item.DesiredQtyBuss + item.DesiredQtyHome;
            }
          }
        } else if (payload.type === "total") {
          if (payload.checked) {
            geo.DesiredQtyHome = geo.AvailableQtyHome;
            geo.DesiredQtyApt = geo.AvailableQtyApt;
            geo.DesiredQtyBuss = geo.AvailableQtyBuss;
            geo.DesiredQty = geo.AvailableQty;
            for (let item of geo.OrderGeoDetails) {
              item.DesiredQtyHome = item.AvailableQtyHome;
              item.DesiredQtyApt = item.AvailableQtyApt;
              item.DesiredQtyBuss = item.AvailableQtyBuss;
              item.DesiredQty = item.AvailableQty;
            }
          } else {
            geo.DesiredQtyHome = 0;
            geo.DesiredQtyApt = 0;
            geo.DesiredQtyBuss = 0;
            geo.DesiredQty = 0;
            for (let item of geo.OrderGeoDetails) {
              item.DesiredQtyHome = 0;
              item.DesiredQtyApt = 0;
              item.DesiredQtyBuss = 0;
              item.DesiredQty = 0;
            }
          }
        }
        geo.DesiredQty =
          geo.DesiredQtyHome + geo.DesiredQtyApt + geo.DesiredQtyBuss;
      }
      homeTotal = homeTotal + ordergeos[i].DesiredQtyHome;
      aptsTotal = aptsTotal + ordergeos[i].DesiredQtyApt;
      bussTotal = bussTotal + ordergeos[i].DesiredQtyBuss;
    }
    commit("saveKey", ["OrderGeos", ordergeos]);
    commit("saveKey", ["DesiredQtyHome", homeTotal]);
    commit("saveKey", ["DesiredQtyApt", aptsTotal]);
    commit("saveKey", ["DesiredQtyBuss", bussTotal]);
    commit("saveKey", ["TotalDesiredQty", homeTotal + aptsTotal + bussTotal]);
    dispatch("calculatePrice");
  },
  changeZipGeoDetailCount({ state, commit, dispatch }, payload) {
    Vue.http
      .post("PlaceOrder.aspx/UpdateDesiredQtyOfOrderGeoDetails", {
        DesiredQty: Number(payload.count),
        geoDetailsIndex: payload.index,
        geoIndex: payload.rowIndex
      })
      .then(resp => {});
    let ordergeos = state.OrderGeos;
    let difference = 0;
    for (var i = 0; i < ordergeos.length; i++) {
      if (i === payload.rowIndex) {
        let geo = ordergeos[payload.rowIndex];
        for (let j = 0; j < geo.OrderGeoDetails.length; j++) {
          if (j === payload.index) {
            difference = geo.OrderGeoDetails[j].DesiredQty - payload.count;
            geo.OrderGeoDetails[j].DesiredQty =
              geo.OrderGeoDetails[j].DesiredQty - difference;
            geo.DesiredQty = geo.DesiredQty - difference;
          }
        }
      }
    }
    commit("saveKey", ["OrderGeos", ordergeos]);
    commit("saveKey", ["TotalDesiredQty", state.TotalDesiredQty - difference]);
    dispatch("calculatePrice");
  },
  changeGeoDetailCount({ state, commit, dispatch }, payload) {
    let ordergeos = state.OrderGeos;
    let homeTotal = 0;
    let aptsTotal = 0;
    let bussTotal = 0;
    for (var i = 0; i < ordergeos.length; i++) {
      if (i === payload.rowIndex) {
        let geo = ordergeos[payload.rowIndex];
        if (payload.type === "homes") {
          geo.DesiredQtyHome = 0;
          for (let j = 0; j < geo.OrderGeoDetails.length; j++) {
            if (j === payload.index) {
              geo.OrderGeoDetails[j].DesiredQtyHome = payload.count;
              geo.OrderGeoDetails[j].DesiredQty =
                geo.OrderGeoDetails[j].DesiredQtyHome +
                geo.OrderGeoDetails[j].DesiredQtyBuss +
                geo.OrderGeoDetails[j].DesiredQtyApt;
            }
            geo.DesiredQtyHome =
              geo.DesiredQtyHome + geo.OrderGeoDetails[j].DesiredQtyHome;
          }
        } else if (payload.type === "apts") {
          geo.DesiredQtyApt = 0;
          for (let j = 0; j < geo.OrderGeoDetails.length; j++) {
            if (j === payload.index) {
              geo.OrderGeoDetails[j].DesiredQtyApt = payload.count;
              geo.OrderGeoDetails[j].DesiredQty =
                geo.OrderGeoDetails[j].DesiredQtyHome +
                geo.OrderGeoDetails[j].DesiredQtyBuss +
                geo.OrderGeoDetails[j].DesiredQtyApt;
            }
            geo.DesiredQtyApt =
              geo.DesiredQtyApt + geo.OrderGeoDetails[j].DesiredQtyApt;
          }
        } else if (payload.type === "business") {
          geo.DesiredQtyBuss = 0;
          for (let j = 0; j < geo.OrderGeoDetails.length; j++) {
            if (j === payload.index) {
              geo.OrderGeoDetails[j].DesiredQtyBuss = payload.count;
              geo.OrderGeoDetails[j].DesiredQty =
                geo.OrderGeoDetails[j].DesiredQtyHome +
                geo.OrderGeoDetails[j].DesiredQtyBuss +
                geo.OrderGeoDetails[j].DesiredQtyApt;
            }
            geo.DesiredQtyBuss =
              geo.DesiredQtyBuss + geo.OrderGeoDetails[j].DesiredQtyBuss;
          }
        } else if (payload.type === "total") {
          geo.DesiredQtyHome = 0;
          geo.DesiredQtyApt = 0;
          geo.DesiredQtyBuss = 0;
          geo.DesiredQty = 0;
          for (let j = 0; j < geo.OrderGeoDetails.length; j++) {
            if (j === payload.index) {
              if (payload.count > 0) {
                geo.OrderGeoDetails[j].DesiredQtyHome =
                  geo.OrderGeoDetails[j].AvailableQtyHome;
                geo.OrderGeoDetails[j].DesiredQtyApt =
                  geo.OrderGeoDetails[j].AvailableQtyApt;
                geo.OrderGeoDetails[j].DesiredQtyBuss =
                  geo.OrderGeoDetails[j].AvailableQtyBuss;
                geo.OrderGeoDetails[j].DesiredQty =
                  geo.OrderGeoDetails[j].AvailableQty;
              } else {
                geo.OrderGeoDetails[j].DesiredQtyHome = 0;
                geo.OrderGeoDetails[j].DesiredQtyApt = 0;
                geo.OrderGeoDetails[j].DesiredQtyBuss = 0;
                geo.OrderGeoDetails[j].DesiredQty = 0;
              }
            }
            geo.DesiredQtyHome =
              geo.DesiredQtyHome + geo.OrderGeoDetails[j].DesiredQtyHome;
            geo.DesiredQtyApt =
              geo.DesiredQtyApt + geo.OrderGeoDetails[j].DesiredQtyApt;
            geo.DesiredQtyBuss =
              geo.DesiredQtyBuss + geo.OrderGeoDetails[j].DesiredQtyBuss;
          }
        }
        geo.DesiredQty =
          geo.DesiredQtyHome + geo.DesiredQtyApt + geo.DesiredQtyBuss;
      }
      homeTotal = homeTotal + ordergeos[i].DesiredQtyHome;
      aptsTotal = aptsTotal + ordergeos[i].DesiredQtyApt;
      bussTotal = bussTotal + ordergeos[i].DesiredQtyBuss;
    }
    commit("saveKey", ["OrderGeos", ordergeos]);
    commit("saveKey", ["DesiredQtyHome", homeTotal]);
    commit("saveKey", ["DesiredQtyApt", aptsTotal]);
    commit("saveKey", ["DesiredQtyBuss", bussTotal]);
    commit("saveKey", ["TotalDesiredQty", homeTotal + aptsTotal + bussTotal]);
    dispatch("calculatePrice");
  },
  changeTotalCount({ state, commit, dispatch }, payload) {
    let orderGeos = state.OrderGeos;
    var value = Number(payload.totalCount);
    var maxValue = state.TotalAvailableQty;
    if (value > maxValue) {
      value = maxValue;
    }
    if (orderGeos.length < 1) {
      Vue.http
        .post("PlaceOrder.aspx/RedistributeOrderTotalQty", {
          totalDesiredQty: value
        })
        .then(resp => {
          if (resp.body.d.ResultFlag) {
            commit("saveKey", ["TotalDesiredQty", value]);
            dispatch("calculatePrice");
          }
        });
    } else {
      let percent = value / maxValue;
      let lostValue = maxValue - value;
      let desired;
      for (var i = 0; i < orderGeos.length; i++) {
        if (
          orderGeos[i].OrderGeoDetails &&
          orderGeos[i].OrderGeoDetails.length > 0
        ) {
          orderGeos[i].DesiredQty = 0;
          for (var j = 0; j < orderGeos[i].OrderGeoDetails.length; j++) {
            desired = Math.round(
              orderGeos[i].OrderGeoDetails[j].AvailableQty * percent
            );
            orderGeos[i].OrderGeoDetails[j].DesiredQty = desired;
            orderGeos[i].DesiredQty += desired;
            lostValue =
              lostValue -
              (orderGeos[i].OrderGeoDetails[j].AvailableQty -
                orderGeos[i].OrderGeoDetails[j].DesiredQty);
          }
        } else {
          desired = Math.round(orderGeos[i].AvailableQty * percent);
          orderGeos[i].DesiredQty = desired;
          lostValue =
            lostValue - (orderGeos[i].AvailableQty - orderGeos[i].DesiredQty);
        }
      }
      // Revers the value to help calculate
      lostValue = 0 - lostValue;
      if (lostValue !== 0) {
        for (let i = 0; i < orderGeos.length; i++) {
          if (
            orderGeos[i].OrderGeoDetails &&
            orderGeos[i].OrderGeoDetails.length > 0
          ) {
            for (let j = 0; j < orderGeos[i].OrderGeoDetails.length; j++) {
              if (lostValue === 0) break;
              var newValue =
                orderGeos[i].OrderGeoDetails[j].DesiredQty + lostValue;
              if (
                newValue < 0 ||
                newValue > orderGeos[i].OrderGeoDetails[j].AvailableQty
              ) {
                if (
                  orderGeos[i].OrderGeoDetails[j].DesiredQty !==
                  orderGeos[i].OrderGeoDetails[j].AvailableQty
                ) {
                  if (lostValue > 0) {
                    lostValue =
                      lostValue -
                      (orderGeos[i].OrderGeoDetails[j].AvailableQty -
                        orderGeos[i].OrderGeoDetails[j].DesiredQty);
                    orderGeos[i].OrderGeoDetails[j].DesiredQty =
                      orderGeos[i].OrderGeoDetails[j].AvailableQty;
                  } else if (lostValue < 0) {
                    lostValue =
                      lostValue + orderGeos[i].OrderGeoDetails[j].DesiredQty;
                    orderGeos[i].OrderGeoDetails[j].DesiredQty = 0;
                  }
                }
              } else {
                orderGeos[i].OrderGeoDetails[j].DesiredQty = newValue;
                lostValue = 0;
                break;
              }
            }
          }
        }
        // }
        // //orderGeos[index].DesiredQty = value;
        // $.each(orderGeos, function(index, value) {
        //   orderGeos[index].DesiredQty = 0;
        //   $.each(orderGeos[index].OrderGeoDetails, function(index2, value2) {
        //     orderGeos[index].DesiredQty += value2.DesiredQty
        //   })
        // })
        for (let i = 0; i < orderGeos.length; i++) {
          orderGeos[i].DesiredQty = 0;
          for (let j = 0; j < orderGeos[i].OrderGeoDetails.length; j++) {
            orderGeos[i].DesiredQty +=
              orderGeos[i].OrderGeoDetails[j].DesiredQty;
          }
        }
      }
      commit("saveKey", ["OrderGeos", orderGeos]);
      commit("saveKey", ["TotalDesiredQty", value]);
      dispatch("calculatePrice");
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/order/actions.js